import * as React from 'react';
import StandaloneOnly from '../standalone-only';
import AddMetaDescription from './add-meta-description';

import { WEBSITE_MODE } from '@sitegen/common/constants';

const MetaDescription: React.FC<IMetaDescriptionProps> = ({ mode }) => (
    <StandaloneOnly mode={mode}>
        <AddMetaDescription />
    </StandaloneOnly>
);

interface IMetaDescriptionProps {
    mode: WEBSITE_MODE;
}

export default MetaDescription;
